/**
 * TableFeaturesHeader component
 * Used to display the header for the Table Features and Tips section.
 * 
 * @returns {JSX.Element} The rendered TableFeaturesHeader component.
 */
export const TableFeaturesHeader = () => (
    <b style={{ fontSize: '1.2em', marginBottom: '0.5em' }}>Table Features and Tips:</b>
);